export const SITE_NAME = process.env.REACT_APP_SITE_NAME || "DataHub";
export const STOREFRONT_DOMAIN = process.env.REACT_APP_STOREFRONT_DOMAIN || "lvh.me";
export const MAIN_SITE_URL = process.env.REACT_APP_MAIN_SITE_URL || "http://localhost:3000";
